import styles from "./select.module.css";

export default function Select({ label, disabled, value, onClick, onChange, placeholder, children }) {
    return (
        <div className={styles.container}>
            <label className={styles.label}>{label}</label>
            <select
              disabled={disabled}
              value={value}
              onClick={onClick}
              onChange={(e) => onChange(e.target.value)}
              className={styles.select}
            >
                {placeholder != null &&
                    <option disabled selected>{placeholder}</option>
                }
                {children}
            </select>
        </div>)
}